import { api } from '../config/api';

// Prefijo centralizado para endpoints de autenticación
const AUTH_PREFIX = '/auth';

// Helper para obtener la URL base para logs (sin /api)
const getBaseUrlForLog = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:8000';
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return 'http://127.0.0.1:8000';
};

export const authService = {
  // Login
  login: async (email, password) => {
    try {
      console.log('🔐 Intentando login...');
      console.log('  Email:', email);
      console.log('  Endpoint:', `${AUTH_PREFIX}/login/`);
      console.log('  Base URL:', getBaseUrlForLog());
      
      const response = await api.post(`${AUTH_PREFIX}/login/`, { email, password }, { skipAuth: true });
      
      console.log('✅ Respuesta del login recibida:', response);
      console.log('  Tiene access_token:', !!response?.access_token);
      console.log('  Token type:', response?.token_type);
      
      if (response && response.access_token) {
        localStorage.setItem('token', response.access_token);
        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token);
        }
        console.log('✅ Token guardado en localStorage');
        return response;
      } else {
        console.error('❌ Respuesta inválida del login:', response);
        throw new Error('No se recibió un token de acceso válido');
      }
    } catch (error) {
      console.error('❌ Error en login:', error);
      console.error('  Error name:', error?.name);
      console.error('  Error message:', error?.message);
      console.error('  Es error de conexión:', error?.isConnectionError);
      console.error('  Stack:', error?.stack);
      
      // Re-lanzar el error para que el AuthContext lo maneje
      throw error;
    }
  },

  // Registro
  register: async (userData) => {
    const response = await api.post(`${AUTH_PREFIX}/register/`, userData, { skipAuth: true });
    return response;
  },

  // Obtener usuario actual
  getCurrentUser: async () => {
    return await api.get(`${AUTH_PREFIX}/me/`);
  },

  // Logout
  logout: async () => {
    // Verificar si hay token antes de intentar logout del servidor
    const token = localStorage.getItem('token');
    
    // Si hay token, intentar logout del servidor
    if (token) {
      try {
        // Intentar llamar al endpoint de logout en el servidor
        await api.post(`${AUTH_PREFIX}/logout/`);
      } catch (error) {
        // Si falla (por ejemplo, token expirado), no es crítico - continuar con logout local
        // No loguear errores de autenticación para evitar spam en consola
        if (error.name !== 'AuthenticationError') {
          console.warn('[AUTH SERVICE] Error en logout del servidor (no crítico):', error.message);
        }
      }
    }
    
    // Siempre limpiar el token local (incluso si no había token)
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
  },

  // Verificar si está autenticado
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Obtener token
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Solicitar reset de contraseña
  requestPasswordReset: async (email) => {
    try {
      const response = await api.post(`${AUTH_PREFIX}/request-password-reset/`, { email }, { skipAuth: true });
      return response;
    } catch (error) {
      console.error('Error solicitando reset de contraseña:', error);
      throw error;
    }
  },

  // Resetear contraseña con token
  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post(`${AUTH_PREFIX}/reset-password/`, { token, new_password: newPassword }, { skipAuth: true });
      return response;
    } catch (error) {
      console.error('Error reseteando contraseña:', error);
      throw error;
    }
  },
};

